import React from 'react';
import bemify from 'bemify-js';

import Link from 'app/common/components/Link';

import BashCodeBlock from '../components/BashCodeBlock';
import Code from '../components/Code';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';
import SyntaxHighlighter from '../components/SyntaxHighlighter';

const bem = bemify('deploying');

const codeBlock = `Preparing to build and upload your app.

Looks like this is your first push. Let's register your app on Zapier.
Enter app title (Ctrl-C to cancel): GitHub Example
Registering a new app on Zapier named "GitHub Example"

  Confirming registation of app "GitHub Example" ⠃ done!
  Linking app to current directory with \`.zapierapprc\` ⠃ done!
  Copying project to temp directory ⠃ done!
  Installing project dependencies ⠃ done!
  Applying entry point file ⠃ done!
  Building app definition.json ⠃ done!
  Validating project ⠃ done!
  Zipping project and dependencies ⠃ done!
  Testing build ⠃ done!
  Cleaning up temp directory ⠃ done!
  Uploading version 1.0.0 ⠃ done!

Build and upload complete! You should see it in your Zapier editor at https://zapier.com/app/editor now!`;

const Deploying = () => (
  <div className={bem()}>
    <StepTitle>Deploying Your App</StepTitle>
    <Paragraph>
      Alrighty then! Enough poking around in our local environment. Let's deploy
      it! When you're ready to try your code out on the Zapier platform use the
      push command. Only you will be able to see the app until you invite
      testers.
    </Paragraph>
    <BashCodeBlock
      lines={[
        {
          content: 'zapier push',
          isCommand: true,
        },
      ]}
    />
    <Paragraph>
      Since this is a new app for your developer account you'll get a prompt
      that asks you to name the app. Name the app anything you want. Then you'll
      see a number of status messages showing you what's going on as the app
      gets deployed...
    </Paragraph>
    <SyntaxHighlighter language="text">{codeBlock}</SyntaxHighlighter>
    <Paragraph>
      <Code>zapier push</Code> is a shortcut for a couple of commands that in
      turn validate, build, package, register, and upload your app to the Zapier
      platform. Once you push your app, you'll be able to see it in the{' '}
      <Link href="/" target="_blank">
        Zapier Platform UI
      </Link>
      .
    </Paragraph>
    <Paragraph>
      You can also now create Zaps with it! Pro tip - If the app doesn't show up
      in "Your Apps", search for the app in the Zap editor by typing the first
      few letters of what you named it.
    </Paragraph>
    <Paragraph>
      Your app will only be visible to you in the Zap editor. We'll talk about
      letting others use your app in the docs.
    </Paragraph>
  </div>
);

export default Deploying;
